const countries: Record<string, string> = {
  BRA: 'BR',
  ARG: 'AR',
  CHL: 'CL',
  COL: 'CO',
  ECU: 'EC',
  PER: 'PE',
  VEN: 'VE',
}

export const getCountryISOAlfa2 = (countryCode: string) => countries[countryCode] || '';
